import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';

const styles = theme => ({
  root: { display: 'block', maxWidth: '100%' }
});

const Image = ({ src, alt, ...rest }) => {

  const { classes, className } = rest;

  return (
    <img src={ src } alt={ alt } className={ classNames( classes.root, className ? className : null ) }/>
  )
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};

export default withStyles(styles)(Image);
